module.exports = __webpack_public_path__ + "img/3dot.a54ce477.svg";